module.exports = __webpack_public_path__ + "img/pc_code@2x.e0cd39ad.png";